import { SAMPLE_ACTION, SAMPLE_ACTION_UPDATE } from './constant'

export const triggerSample = (payload: any) => {
  return { type: SAMPLE_ACTION, payload }
}

export const updateTriggerSample = (payload: any) => {
  return { type: SAMPLE_ACTION_UPDATE, payload }
}